<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =  [{"num_cand":"U2FsdGVkX18zYoD98vuhAA7Zg/rbOE8JNn8w41xO01Y=","cpf":"U2FsdGVkX1/tA750iLF+3ovHr9iPSIeKlP8wDarKWWw="},{"num_cand":"U2FsdGVkX1+ehWCGKK16G0I4rw2eoESXUzkgYHmqk+0=","cpf":"U2FsdGVkX1/ymJbXTAo6oTjpgDmukcYdOVFUJA3sjsM="},{"num_cand":"U2FsdGVkX1+bOLS8R+otwdaxdeTOc/9Csl1u3YCxtUs=","cpf":"U2FsdGVkX1+jRVuUdt0wwNw4j76eqh+pCNCZ5ILhK/g="},{"num_cand":"U2FsdGVkX18MJk55NQKVIasZVk1WNnsX3w6+JnPArBU=","cpf":"U2FsdGVkX1+frNqhnzegNwA5UToQ24Mj4gaQExk5Gfg="},{"num_cand":"U2FsdGVkX1+IaRQYldT8UsRyRaiDnGzMlaGarzh6NuU=","cpf":"U2FsdGVkX19O7eGZynWBkxMUP5ACrxccDuFveKyKU08="},{"num_cand":"U2FsdGVkX1/wVHLN8P3NjMz0mn6Xa1j+o6STzVV30Fc=","cpf":"U2FsdGVkX19v3HVs9dTmTtQsJhSIm073RNcsCa/Zm6k="},{"num_cand":"U2FsdGVkX18jKUJRBDqb57uJK+ydXaxQcLPQUfIY2ME=","cpf":"U2FsdGVkX1/Hi1XXhEQGXQqPlp7La1tElNjlNgYv/Os="},{"num_cand":"U2FsdGVkX195VZ30EtT5k1yTHMhSR+/PcZIZj7HebiU=","cpf":"U2FsdGVkX1+880cwGtRK7ISFKTEdeGH5DbDJULdMDcE="},{"num_cand":"U2FsdGVkX1/HOeFzOQHO0JfhQS5ZDgx4A/WlFYEd91s=","cpf":"U2FsdGVkX19s0X9ZpfzSmc7na3W82f+0uGNtGJLQBs4="},{"num_cand":"U2FsdGVkX19nqynb5zJE5JY4ZTAXIyIBgJfdQJ/uX0o=","cpf":"U2FsdGVkX1+zhjA+EQerNfBNvzrC2uZ/aVr121lNy1U="},{"num_cand":"U2FsdGVkX1+iZIOj3g/T0KbLLK5CHGSx2usMquYDJZ0=","cpf":"U2FsdGVkX19kuF0vRt7YvprTtdE65DJmtCQ3zgcXY2o="},{"num_cand":"U2FsdGVkX1+RSmNigOhBty+SB8JGZySdVU+QW87HGnY=","cpf":"U2FsdGVkX1/Lbex8aPxaDr4o5soCiMtmQq+Wh1xkFxM="},{"num_cand":"U2FsdGVkX18McT3kfdBlHoTeA4+aglFSE+1ymCkvPtw=","cpf":"U2FsdGVkX1/u6oV7s9CwBtDH45DiP6yFL5Il6zKhAQc="},{"num_cand":"U2FsdGVkX19UKO62lpu/VnzefR2abfE8JXaokArRY8Y=","cpf":"U2FsdGVkX1+HnD6wLUaBhssOmmmtKR/MVD6e6mLM27Y="},{"num_cand":"U2FsdGVkX19eW5TUOPIWcjcZJ1loJjf71OVKih9utCk=","cpf":"U2FsdGVkX18iZ8n3MPfohVGSAjnzW5UlsWvJjHp8Mio="},{"num_cand":"U2FsdGVkX1+4xO8qQbCg/Ci4wwdT/osl06OBcKrx2Bs=","cpf":"U2FsdGVkX1/G3BTMPgfyiajuA2mYoXi75dmnWvAMk1o="},{"num_cand":"U2FsdGVkX1+qod68rWVtdaymNIAD3oQ35gOqE/j79ho=","cpf":"U2FsdGVkX19dkBBOlFfF4Q/CQI8937kKvhlhmqfvq5A="},{"num_cand":"U2FsdGVkX1+4OFHPUiDN7zKmKk9SLYMfjFqiQK9S/Xg=","cpf":"U2FsdGVkX1+X50pxnKIWQLvbc6vVDxaq4iI3x/pSM68="},{"num_cand":"U2FsdGVkX191WkmwlX4Ph5JuLfO+QwIo1is8gJUT3W0=","cpf":"U2FsdGVkX1+MsPXvkHiyDiy9iAXZwulpAAIezRsXJmw="},{"num_cand":"U2FsdGVkX19EdxQgxi1xk9isPk3b7OzP0Tn6rwp9Ptg=","cpf":"U2FsdGVkX18BAdqysU1QdcWKERAONvcIZBRtsiqq//s="},{"num_cand":"U2FsdGVkX1/bLIeCLjBJt5a9oGnUJIEkn1M6a75AXdw=","cpf":"U2FsdGVkX192zWPwDIozRh8VXcgqolvk/1jPdT8Pdp0="},{"num_cand":"U2FsdGVkX1+ynL2rcSXIvsskyAX2kGzMMkcsbzsuErY=","cpf":"U2FsdGVkX1/8jCpn8IpoCmw3/H8KwlnE15nl60XtTEM="},{"num_cand":"U2FsdGVkX1+zLD7cWoJkKA4XkRTdW+kCeMN3iGLxRjk=","cpf":"U2FsdGVkX19zXYGrcMG1cb/MZs00ZIGCQEzWfgKjbxw="},{"num_cand":"U2FsdGVkX18zrl0FdkSXUChsPpPTXq/6Qs8hyMXoFDs=","cpf":"U2FsdGVkX1+ELiT4tJ2brTBD/NMW3BQEGs38YyJnEC4="}]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2218/rec_isenc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
